import {Backdrop} from '../../js/modules/home/backdrop';
import {Menu} from '../../js/modules/home/header/menu';
import {Search} from '../../js/modules/home/header/search';

export class HomedealHeader {
    private readonly backdrop: Backdrop;
    private readonly menu: Menu;
    private readonly search: Search;

    constructor() {
        this.backdrop = new Backdrop();
        this.menu = new Menu(this.backdrop);
        this.search = new Search(this.menu, this.backdrop);
    }
}

(<any>window).skyComponents = (<any>window).skyComponents || {};
(<any>window).skyComponents.homedealHeader = new HomedealHeader();
